import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, BUTTON_TYPE, BUTTON_VARIANT } from '../ButtonSMB'
import useStyles from './styles'
import { ISupportFooterProps } from './types'

import { GA4_ACTIONS, GA4_PLACES, Mixpanel, onSendGA4Event, sendGA4Event } from '@/analytics'
import { openDashlyChat } from '@/analytics/dashly'
import { Routes } from '@/const/routes'

const SupportFooter = (props: ISupportFooterProps) => {
  const { signIn = false } = props

  const classes = useStyles()
  const intl = useIntl()

  const onClick = () => {
    Mixpanel.track('EntranceGotoChat')
    if (!signIn) {
      sendGA4Event({ action: GA4_ACTIONS.SIGNUP_CHAT_CLICK, place: GA4_PLACES.SIGNUP, page: '0' })
    }
    openDashlyChat()
  }

  return (
    <div className={classes.root}>
      <div className={classes.block}>
        <span className={classes.text}>
          <FormattedMessage id={signIn ? 'signUp.root.alreadyHaveAccount' : 'signIn.root.hasNoAccount'} />
        </span>
        <Button
          type={BUTTON_TYPE.text}
          variant={BUTTON_VARIANT.secondaryPurple}
          label={intl.formatMessage({ id: signIn ? 'common.signIn' : 'signIn.root.signUp' })}
          to={signIn ? Routes.SIGN_IN : Routes.SIGN_UP}
          className={classes.button}
          onClick={onSendGA4Event({ action: signIn ? GA4_ACTIONS.SIGNIN_ENTER_CLICK : GA4_ACTIONS.SIGNUP_ENTER_CLICK })}
        />
      </div>
      <div className={classes.block}>
        <span className={classes.text}>
          <FormattedMessage id="signIn.root.somethingWrong" />
        </span>
        <Button
          type={BUTTON_TYPE.text}
          variant={BUTTON_VARIANT.tertiary}
          label={intl.formatMessage({ id: 'signIn.root.chat' })}
          className={classes.button}
          onClick={onClick}
        />
      </div>
    </div>
  )
}

export default memo(SupportFooter)
